package com.mgacreative.hotel.feature.staff.ui

import androidx.lifecycle.ViewModel
import com.mgacreative.hotel.domain.repository.StaffRepository
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotel.core.network.SupabaseNetworkClient
import com.mgacreative.hotel.core.tenant.TenantSession
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import com.mgacreative.hotel.domain.repository.DepartmentRepository
import com.mgacreative.hotel.domain.model.Department

data class Shift(val id: String, val staffName: String, val date: String, val shiftType: String, val tenantId: String)
data class LeaveRequest(val id: String, val staffName: String, val dates: String, val status: String, val tenantId: String)
data class Permission(val key: String, val name: String, var isEnabled: Boolean)

class StaffViewModel(
    private val supabaseClient: SupabaseNetworkClient,
    private val tenantSession: TenantSession,
    private val staffRepository: StaffRepository,
    private val departmentRepository: DepartmentRepository
) : ViewModel() {

    private val _shifts = MutableStateFlow<List<Shift>>(emptyList())
    val shifts: StateFlow<List<Shift>> = _shifts.asStateFlow()

    // Real Staff from DB
    val staffList = staffRepository.staffList
    
    private val _departments = MutableStateFlow<List<Department>>(emptyList())
    val departments: StateFlow<List<Department>> = _departments.asStateFlow()

    private val _leaveRequests = MutableStateFlow<List<LeaveRequest>>(emptyList())
    val leaveRequests: StateFlow<List<LeaveRequest>> = _leaveRequests.asStateFlow()

    // Global simulation of permissions for "Yetki değişikliği anında güncelleniyor"
    private val _permissions = MutableStateFlow<List<Permission>>(emptyList())
    val permissions: StateFlow<List<Permission>> = _permissions.asStateFlow()

    init {
        loadData()
        viewModelScope.launch {
            staffRepository.loadStaff()
            departmentRepository.getDepartments().collect { deps ->
                _departments.value = deps
            }
        }
    }

    private fun loadData() {
        val currentTenantId = (tenantSession.currentTenantId ?: "")

        // Acceptance Criteria: Bir personelin vardiya/izin kayıtları yalnızca kendi tenant'ında görünüyor
        val allShifts = emptyList<Shift>()
        
        _shifts.value = allShifts.filter { it.tenantId == currentTenantId }

        val allLeaves = emptyList<LeaveRequest>()
        _leaveRequests.value = allLeaves.filter { it.tenantId == currentTenantId }

        _permissions.value = emptyList()
    }

    fun approveLeave(leaveId: String) {
        _leaveRequests.value = _leaveRequests.value.map {
            if (it.id == leaveId) it.copy(status = "APPROVED") else it
        }
    }

    fun rejectLeave(leaveId: String) {
        _leaveRequests.value = _leaveRequests.value.map {
            if (it.id == leaveId) it.copy(status = "REJECTED") else it
        }
    }

    // Acceptance Criteria: Yetki değişikliği anında güncelleniyor (StateFlow updates trigger UI recomposition)
    fun togglePermission(key: String, isEnabled: Boolean) {
        _permissions.value = _permissions.value.map {
            if (it.key == key) it.copy(isEnabled = isEnabled) else it
        }
    }

    fun addStaff(fullName: String, department: String) {
        viewModelScope.launch {
            staffRepository.addStaff(
                com.mgacreative.hotel.domain.model.Staff(
                    full_name = fullName,
                    department = department
                )
            )
        }
    }
}
